<template>
<div class="MeterViewDiagram">
  <div v-if="isEditor===true" id="mountNode-editor" ref="mountNodeEditor"></div>
  <div v-if="isEditor===false" id="mountNode-view" ref="mountNodeEView"></div>
  <SelectMeter ref="SelectMeter" />
  <ApportionWin ref="ApportionWinRef" />
  <MeterEditor ref="MeterEditorRef"/>
  <div class="MeterTreeWin">
    <MeterTreeComponent height="100vh" :project_id="mainObj.project_id" ref="MeterTreeComponentRef" @onClick="onClickMeter" />
  </div>
  <div class="minimap-container" id="minimap-container"></div>
</div>
</template>

<script>
import G6 from "@antv/g6";
import SelectMeter from "./SelectMeter";
import {menu, MeterTreeItem, toolbar, tooltip} from "./common/G6HelpSimple";
import ApportionWin from "./apportion/ApportionWin";
import MeterEditor from "./MeterEditor";
import MeterTreeComponent from "./MeterTreeComponent";
import MeterHttp from "../../../common/MeterHttp";


let meter_list=[];
// 实例化 minimap 插件
const minimap = new G6.Minimap({
  container: document.getElementById('minimap-container'),
  size: [100, 100],
  className: 'minimap-container',
  type: 'delegate',
});
export default {
  name: "MeterViewSimpleDiagram",
  inject:['mainObj','componentId','setComponentId'],
  components: {MeterTreeComponent, MeterEditor, ApportionWin, SelectMeter},
  props:{
    isEditor:{
      type:Boolean,
      default() {
        return false;
      }
    }
  },
  data(){
    return {
      defaultConfig:{
        width: window.innerWidth,
        height: window.innerHeight,
        modes: {
          default: [
            {
              type: 'collapse-expand',
              onChange: function onChange(item, collapsed) {
                const data = item.getModel();
                data.collapsed = collapsed;
                return true;
              },
              shouldBegin: (e, self) => {
                // 若当前操作的节点 id 为 'node1'，则不发生 collapse-expand
                const { item, target } = e;
                const targetType = target.get('type');
                return targetType !== 'image';

              },
            },
            'zoom-canvas',
            'drag-canvas',
            {
              type: 'create-edge',
              shouldEnd: e => {
                // avoid ending at other shapes on the node
                console.log(e.target)
                console.log(this.treeGraph.save())
                if (e.target && e.target.get('name') !== 'anchor-point') return false;
                console.log(e.target)
                // if (e.target) {
                //   targetAnchorIdx = e.target.get('anchorPointIdx');
                //   e.target.set('links', e.target.get('links') + 1);  // cache the number of edge connected to this anchor-point circle
                //   return true;
                // }
                // targetAnchorIdx = undefined;
                return true;
              },
            },
            // 'drag-node',
            'click-select',
            // tooltip,
          ],

        },
        fitView: true, // 开启画布自适应。开启后图自动适配画布大小
        animate: true,
        // 节点样式
        defaultNode: {
          type: 'flow-rect', // flow-rect我们自定义的样式名称，告诉画板要引用哪个模块
          style: {
            fill: '#FFFFFF', // 默认的模板填充色
            hover: {
              fill: 'lightsteelblue',
            },
          },
          anchorPoints: [
            [1, 0.5],
            [1, 0.5]
          ],
          // 默认的模板的文字的填充色
          labelCfg: {
            style: {
              fill: '#000000',
              fontSize: 20,
              fontWeight: 800
            }
          }
        },
        // 线的样式
        defaultEdge: {
          type: 'polyline',
          size: 3, // 粗细
          style: {
            stroke: '#CED4D9'
          }
        },
        // 布局
        layout: {
          type: 'compactBox', // 布局类型
          direction: 'LR', // 展开的方向
          align: 'DL', // 节点的排列方式
          // 与子节点的相差的高度
          getHeight: () => {
            return 120
          },
          // 与子节点的相差的宽度
          getWidth: () => {
            return 250
          },
          getVGap: function getVGap() {
            return 10;
          },
          getHGap: function getHGap() {
            return 30;
          },
        },
        maxZoom: 1, // 展开时的放缩比例
        plugins: [tooltip,menu(this),minimap]//toolbar
      },
      meter_line:{
        label:'线路架构图',
        type: 'rect',
        size: [300, 40],
        // 锚点
        anchorPoints: [
          [1, 0.5],
          [1, 0.5]
        ],
        getHeight: () => {
          return 10
        },
        getWidth: () => {
          return 150
        },
        children:[],
      },
      dialogVisible:false,
      excel_value:"",
      treeGraph:null,
    }
  },
  created() {

  },
  mounted() {
    const that=this;
    that.onLoad(list=>{
      meter_list=list;
      that.initData()
    })
  },
  methods:{
    initData(){
      const that=this;
      that.initGraph()
    },
    reData(){
      const that=this;
      let meter_line=getHeaderTree(that.mainObj.map_id,meter_list);
      that.meter_line.children=ERP.reJson(meter_line);
      that.treeGraph.data(that.meter_line) // 加载数据
      setTimeout(function () {
        that.treeGraph.render() // 渲染
      },200);
    },
    initGraph(){
      const that=this;
      // 默认配置
      const defaultConfig = this.defaultConfig;
      // 自定义节点和边
      const registerFn = () => {
        /**
         * 自定义节点
         */
        G6.registerNode(
          'flow-rect', // 自定义的节点名称，在上面进行引用
          {
            shapeType: 'flow-rect',
            // 这里涉及到模板的生命周期函数，官网上面有详细的讲解
            draw(cfg, group) {
              // 自定义模板
              let rectConfig = {
                width: 250,
                height: 120,
                fill: cfg.meter_virtually===1?'#ffffff':'#96fbfd',
                // fill: '#ffffff',
                shadowOffsetX: 0, // 模板阴影的X轴偏移量
                shadowOffsetY: 0, // 模板阴影的Y轴偏移量
                // shadowColor: cfg.upid?'#999':'#038dce',
                shadowColor: '#999',
                shadowBlur: 10,

              };
              let is_ft_xb=false;
              let meter_number=cfg.number||'';
              if(meter_number.length===14){
                let ft_type=meter_number.slice(6,8);
                is_ft_xb=ft_type==='00';
              }
              if(is_ft_xb){
                rectConfig={
                  ...rectConfig,
                  stroke: '#3b6ed9', // 边框色
                  lineWidth: 2, // 边框宽度
                  lineDash: [10, 5], // 设置虚线，10是线的长度，5是间隔的长度
                }
              }
              // 规定边界，便于定位
              const nodeOrigin = {
                x: -rectConfig.width / 2,
                y: -rectConfig.height / 2
              }
              // 规定文字位置，对齐方式
              const textConfig = {
                textAlign: 'left',
                textBaseline: 'bottom'
              }
              // 初始化模板
              const rect = group.addShape('rect', {
                attrs: {
                  x: nodeOrigin.x,
                  y: nodeOrigin.y,
                  ...rectConfig
                }
              })

              let width=rectConfig.width;
              let height=50;

              const setItem = (label,value,y=60) => {
                group.addShape('text', {
                  attrs: {
                    ...textConfig,
                    x: 9 + nodeOrigin.x,
                    y: y + nodeOrigin.y,
                    text: label,
                    fontSize: 16,
                    fill: '#555',
                    opacity: 1
                  }
                })
                group.addShape('text', {
                  attrs: {
                    ...textConfig,
                    x: 90 + nodeOrigin.x,
                    y: y + nodeOrigin.y,
                    text: value,
                    fontSize: 16,
                    fontWeight: 800,
                    fill: '#555',
                    opacity: 1
                  }
                })
              }

              group.addShape('rect', {
                attrs: {
                  x: 4 + nodeOrigin.x,
                  y: 30 + nodeOrigin.y,
                  width: rectConfig.width-10,
                  height: 1,
                  fill: '#333',
                  opacity: 0.35
                }
              })

              // 线
              group.addShape('text', {
                attrs: {
                  ...textConfig,
                  x: 9 + nodeOrigin.x,
                  y: 25 + nodeOrigin.y,
                  text: cfg.name,
                  height: 18,
                  fontSize: 16,
                  fontWeight: 800,
                  fill: '#333',
                  opacity: 1
                }
              })

              // 编号
              setItem("仪表编号",cfg.number,60);
              // 能耗类型
              setItem("能耗类型",cfg.energy,85);
              // 仪表等级
              setItem("仪表等级",cfg.meter_level_name,110);


              // if(that.isEditor){
              //   // 如果不需要动态增加或删除元素，则不需要 add 这两个 marker
              //   group.addShape('image', {
              //     attrs: {
              //       x: -width/2,
              //       y: height+height/2+5,
              //       width:30,
              //       height:30,
              //       // r: 10,
              //       // stroke: '#73d13d',
              //       cursor: 'pointer',
              //       // symbol: EXPAND_ICON,
              //       img: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAiRJREFUWEfNl71LVmEYxn/vYkOiLhFFSOIfIEgWtWRTi0FLTu2KgjXU4FQRtBQ05Qe1NjkEFdRWIBHki4OQU5BgJJaLqEtLPRecE895eI7nPueFc3zgLC/3x3V/X2+Lhl+rYf+UAdAHjAKXgfPAyeSTjd/JtwK8A5aBXUtwFgBdwAxwCzhjMQr8BJ4Di8DWYTpFABTpPDBsdByKCchDYCFP/zAAY8Cbio5DtQfuh/sxW3kAbgNPC5x/BGT4FzAO3CuQvwa8DWViAK4DrwyRX3FNKRB6as4PBp0LwBdfLgSghvtsrHmo+9cAYBW4CPxJZUMjd4DHBkMSqQJAeneBJzEAPcDXEqNWFcCPJMPaHZkorgLvjdF3kgHpTgNzoZFHwGxNANS8auJMBj4Bl2oCIDfH1Ix+Hb8Bgx6AdM7TUSuBLSN6yq3jicie6Ac2fQB7rju7PVV/zqs6T/Vie2IEaPsA9t0IHq8RgO7Mig/gO3C2xhIMABs+AK1IpcX6qu6B1L7KfeAbeeYOy5TVewebUC7W3L0ZCsew7PntJAP/17FvpNed1XXgtDELVQGIpIjgbMfWqUhD0V3PO2SWayjdDDkJo9DSaBuzUCUDiv6czxNjhGQy4YFFlahCSMSclnzDeZTMUoqylOwm8DKM6siS0hRoo7Q8BdHoHxO/ZCccZbuRfLpusSdC+8LN+Wtgp6iLY3vAoiMZZSX23/DAaiBvmZTV71j+Hw4UayGqBQpFAAAAAElFTkSuQmCC',
              //     },
              //     // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
              //     name: 'add-item',
              //   });
              //
              //   if(cfg.count===0){
              //     group.addShape('image', {
              //       attrs: {
              //         x: -15,
              //         y: height+height/2+5,
              //         width:30,
              //         height:30,
              //         // r: 10,
              //         // stroke: '#ff4d4f',
              //         cursor: 'pointer',
              //         // symbol: COLLAPSE_ICON,
              //         img: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAxpJREFUWEfFl2moTVEYhp9LpiJKQkgRIUOGMkRJxohIErmSKXPGlH8SUShlyFiIkCmEK0WUechUSn4Y/nDNQjKtl2/ftu2cddY6f3x1u+ec/a53vWt94y7hP1tJxP61gZFAE+A98AA4B3yJ4PgHGiKgGrAamAJUyTB8AvYAc4GPxQgJEVAG9CtAfgkYAryOFVFIwAjgYCDpLqA0EFsB8wnQs/tA6wjS5k7E4wg8PgEdgZsxZC4OFli8BC/zCZgKbApm+gPcC4yJWeMTsMKl2OIYMuAq0DVmjU/ABmBaDBnwEGgVsyafAP1+DegcQwaoLnQAHoWuyyegMfA0lCSDU8HaEro2n4AawFugaihRCtcduBy6zhcD44DNQPVQMmA9MDMC760D4jnuYmFwIKEaVF3gWyD+N6xQKe4LnAkkXA4sCcQGleIENNFcUclDfh3oBnwHKgMSru+dgDfALeCsa+f3shyFbiDBq8KN9ggYD+y0GnAKaJoHux9QbH1NnocKWAUszEN63g0mvYGGwA37L6gGle12Gy1Ta/8q1yECdPW3XVtul0eAmpaeXwB6pjCKnf7AcOBQZu0kN1ltCwlCjWG6NhHlsruOvL3L+4GuB5zMAE7b7xpUjmWelQP1gR+5bqAO0Mf+Rrncrufx/UprWOuAWYbTbbyzxrQIUGFSY5NpXlCVlXWRy9ICVP2WuaidY5EcklGTHeFW4IiL9GHmc2VNPlOGPLfTa9o6nBYQMvtliac7so3AbmCsTcqzLR01H96x4pTETwPLFg23A4CyREBbQP6MtbVuRJ9nU/GaiBgQVK4tTwTkCpQQMTqh2q9OpllQbkzMF4RymbKjohSryCg/i7FeLtcv2k3o/SExDSfKkPmuq6pMJ/bZCtaTtIChwNFidgeuOF/2sMMo3QZ5eH66OUNBuiPBJC5oYeNUSGHKxX/A3pyUfhPs1G1SQG18Alhqk1bFo/SGyn31cvlT1S1mDhDhK2CGe4/YZ+zK85r2WSPas1zKC72YSEyjFJGCrJmb/Wu5zV4CL9xpPxixvutFJsqKvfKoTXzgX7fMhCGokbDLAAAAAElFTkSuQmCC',
              //       },
              //       // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
              //       name: 'add-user',
              //     });
              //   }
              //
              //   group.addShape('image', {
              //     attrs: {
              //       x: width/2-30,
              //       y: height+height/2+5,
              //       width:30,
              //       height:30,
              //       // r: 10,
              //       // stroke: '#ff4d4f',
              //       cursor: 'pointer',
              //       // symbol: COLLAPSE_ICON,
              //       img: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAdpJREFUWEfNl00rRVEUhp87VUgYGMjHQBmamZCBMSEfKTIT5RdQUvwCRWYykO9ibCAmRgyVgc+BARJiylm3s3PuuXffvc+5+3Tsye3WWu96Onvtvd6dwX6VA93AMNAC1ADVfvor8AJcA9vAMfBpI52xCGoFZoARoMoiXkLegC0PcNkDviqWYwJY9ItXWBYOh334EHO6/GIAp0BHzMLhtDOgs5CWDuDZ32NH9bMy0iO1YcFCALdAo8vKAa07oCmoHQbYAQYTKq5kd4Eh9ScIIA03m3BxJb8EZBtTAchROwfidntUbjkd7XJEFcAKMBVVpcT4VWBaACqBe/+3RM1I6e9AgwCMARuRUt0FjwvAHjDgTjOS0r4AXABthrSTSLJ/wV2GvEsBeADqNYELwBrwFBOgzsudBOY1+Y8C8AWUaQJMw8qW60cT+P0vAExbsA7IHR5nyUyZMG1B6k0ozkVsVhprW3qgDzhIozrQLwBiNuUqtvV7rljFN2avYlmpDiMBSH0cC0SqhkTtq0snrOuVHIdc6KpNwhErmDxnrLvrk3DGeY5YqIoNG5cOOccJB/fGNO1SfZopUPU4HY3gG8Xvbbp4nAa/lpjXHqDX85DNmuf5jeeuDoEjQCCM6xdPi1eJloDigwAAAABJRU5ErkJggg==',
              //     },
              //     // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
              //     name: 'remove-item',
              //   });
              // }


              return rect
            },
            // 定义锚点，G6会自动连接两个节点的最近的锚点
            getAnchorPoints() {
              return [
                [0, 0.5], // 左侧中间
                [1, 0.5], // 右侧中间
                // [0.5, 0], // 上侧中间
                // [0.5, 1] // 下侧中间
              ]
            }
          },
          'rect'
        )
      };
      registerFn();


      // 画布主体
      that.treeGraph = new G6.TreeGraph({
        container: 'mountNode-'+(that.isEditor?'editor':'view'), // 制定画布的容器
        ...defaultConfig,
        // plugins: [minimap], // 将 minimap 实例配置到图上
      })
      window.treeGraph=that.treeGraph;

      that.treeGraph.on('node:click', (evt) => {
        const { item, target } = evt;
        const targetType = target.get('type');
        const name = target.get('name');

        // 增加元素
        if (targetType === 'image') {
          const model = item.getModel();
          if (name === 'add-item') {
            if (!model.children) {
              model.children = [];
            }
            that.$refs.SelectMeter.show(list=>{
              let meter_ids=list.map(ret=>ret.id);
              that.addPid(model.id,meter_ids,()=>{
                list.forEach(ret=>{
                  model.children.push(MeterTreeItem(ret,list));
                });
                that.treeGraph.updateChild(model, model.id);
              });
            });
          } else if (name === 'remove-item') {
            that.$confirm('是否确认移除', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              that.deleteMeterPid(model.id,()=>{
                that.treeGraph.removeChild(model.id);
              });
            });
          }else if (name === 'add-user') {
            that.$refs.ApportionWinRef.show({id:model.id,name:model.name,number:model.number})
          }
        }
      });

      // 鼠标进入节点
      that.treeGraph.on('node:mouseenter', (e) => {
        const nodeItem = e.item; // 获取鼠标进入的节点元素对象
        // that.treeGraph.setItemState(nodeItem, 'hover', true); // 设置当前节点的 hover 状态为 true
        // that.treeGraph.
        // console.log(nodeItem)
      });

      // 鼠标离开节点
      that.treeGraph.on('node:mouseleave', (e) => {
        const nodeItem = e.item; // 获取鼠标离开的节点元素对象
        // that.treeGraph.setItemState(nodeItem, 'hover', false); // 设置当前节点的 hover 状态为 false
        // console.log(nodeItem)
      });

      // deleteItem: 对于需要单独操作的元素，请在定义数据的时候定义nama值，这样才可以定位到指定元素
      that.treeGraph.on('deleteItem:click', (ev) => {
        const shape = ev.target
        const node = ev.item
      })

      // that.treeGraph.on('beforecreateedge', (e) => {
      //   const edges = that.treeGraph.save().edges;
      //   G6.Util.processParallelEdges(edges);
      //   console.log(edges)
      //   // that.treeGraph.getEdges().forEach((edge, i) => {
      //   //   that.treeGraph.updateItem(edge, {
      //   //     curveOffset: edges[i].curveOffset,
      //   //     curvePosition: edges[i].curvePosition,
      //   //   });
      //   // });
      // });

      // that.treeGraph.on("", evt => {
      //   // 一些操作
      // })

      that.reData();

      const container = document.getElementById('container');
      if (typeof window !== 'undefined')
        window.onresize = () => {
          if (!that.treeGraph || that.treeGraph.get('destroyed')) return;
          if (!container || !container.scrollWidth || !container.scrollHeight) return;
          that.treeGraph.changeSize(container.scrollWidth, container.scrollHeight);
        };


    },
    download(){
      const that=this;
      let time=(new Date()).getTime().toString()
      that.treeGraph.downloadFullImage('仪表架构图_'+time, 'image/png', {
        backgroundColor: '#FFFFFF',
        padding: [30, 15, 15, 15],
      });
    },
    addPid(pid,meter_ids,callback){
      const that=this;
      MeterHttp.post(`Meter/setMeterPid?user_type=${that.$route.query.type||0}`,{
        project_id:that.mainObj.project_id,
        pid:pid,
        meter_ids:meter_ids.join(',')
      },ret=>{
        if(ret.code){
          that.$message.success(ret.msg)
          // that.$emit('onLoad')
          callback()
        }else {
          that.$message.error(ret.msg||"操作异常")
        }
      })
    },
    deleteMeterPid(meter_id,callback){
      const that=this;
      MeterHttp.post(`Meter/deleteMeterPid?user_type=${that.$route.query.type||0}`,{
        project_id:that.mainObj.project_id,
        meter_id:meter_id
      },ret=>{
        if(ret.code){
          that.$message.success(ret.msg)
          // that.$emit('onLoad')
          callback()
        }else {
          that.$message.error(ret.msg||"操作异常")
        }
      })
    },
    onClickMeter(node){
      // this.$emit("onClickMeter",node)
      this.renderData(node.id)
    },
    onLoad(callback){
      const that=this;
      MeterHttp.post(`Meter/getMapTree?user_type=${that.$route.query.type||0}`,{
        project_id:that.mainObj.project_id,
        meter_id:that.mainObj.map_id,
        is_editor:that.isEditor?1:0,
      },ret=>{
        if(ret.code){
          typeof callback==="function"&&callback(ret.data)
        }else {
          that.$message.error(ret.msg||"数据异常")
        }
      })
    },
    renderData(meter_id){
      const that=this;
      that.mainObj.map_id=meter_id;
      that.onLoad(list=>{
        meter_list=list;
        that.reData()
      })
    }
  }
}


function getTree(upid,list=[]){
  let _list=list.filter(re=>re.upid==upid);
  return _list.map(ret=>{
    return MeterTreeItem(ret,list)
  })
}
function getTreeAll(upid,list=[]){
  let root_list=getTree(upid,list)
  root_list=root_list.map(re=>{
    let ls=getTree(re.id,list);
    if(ls.length>0){
      re.children=getTreeAll(re.id,list);
    }
    return re;
  })
  return root_list
}
function getHeaderTree(upid,list=[]) {
  let header_list=list.filter(ret=>ret.id==upid).map(ret=>{
    return MeterTreeItem(ret,list)
  })
  header_list.map(ret=>{
    let ls=getTree(ret.id,list);
    if(ls.length>0){
      ret.children=getTreeAll(ret.id,list);
    }
    return ret;
  })
  return header_list
}

</script>

<style lang="scss" scoped>
$layout_height:calc( 100vh - 40px );
.MeterViewDiagram{
  position: relative;
  .MeterTreeWin{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9;
    //height: $layout_height;
  }
  .minimap-container{
    position: absolute;
    border-bottom: 0;
    left: 0;
    z-index: 9;
  }
  #mountNode{
    height: $layout_height;
    /* 提示框的样式 */
    >>>.g6-tooltip {
      border: 1px solid #e2e2e2;
      border-radius: 4px;
      font-size: 12px;
      color: #545454;
      background-color: rgba(255, 255, 255, 0.9);
      padding: 10px 8px;
      box-shadow: rgb(174, 174, 174) 0px 0px 10px;
    }
    >>>.g6-component-contextmenu{
      padding: 0;
      ul {
        list-style-type: none;
        left: -150px;
        margin: 0;
        padding: 0;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 4px;
        font-size: 14px;
        color: #545454;
        li {
          cursor: pointer;
          list-style: none;
          padding: 5px 10px;
          border-bottom: 1px solid #e1e1e1;
          &:hover {
            background-color: #409eff;
            color: #ffffff;
          }
          &:last-child{
            border-bottom:0;
          }
        }
      }
    }
  }
  #mountNode-view{
    height: $layout_height;
    /* 提示框的样式 */
    >>>.g6-tooltip {
      border: 1px solid #e2e2e2;
      border-radius: 4px;
      font-size: 12px;
      color: #545454;
      background-color: rgba(255, 255, 255, 0.9);
      padding: 10px 8px;
      box-shadow: rgb(174, 174, 174) 0px 0px 10px;
    }
    >>>.g6-component-contextmenu{
      padding: 0;
      ul {
        list-style-type: none;
        left: -150px;
        margin: 0;
        padding: 0;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 4px;
        font-size: 14px;
        color: #545454;
        li {
          cursor: pointer;
          list-style: none;
          padding: 5px 10px;
          border-bottom: 1px solid #e1e1e1;
          &:hover {
            background-color: #409eff;
            color: #ffffff;
          }
          &:last-child{
            border-bottom:0;
          }
        }
      }
    }
  }
  #mountNode-editor{
    height: $layout_height;
    /* 提示框的样式 */
    >>>.g6-tooltip {
      border: 1px solid #e2e2e2;
      border-radius: 4px;
      font-size: 12px;
      color: #545454;
      background-color: rgba(255, 255, 255, 0.9);
      padding: 10px 8px;
      box-shadow: rgb(174, 174, 174) 0px 0px 10px;
    }
    >>>.g6-component-contextmenu{
      padding: 0;
      ul {
        list-style-type: none;
        left: -150px;
        margin: 0;
        padding: 0;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 4px;
        font-size: 14px;
        color: #545454;
        li {
          cursor: pointer;
          list-style: none;
          padding: 5px 10px;
          border-bottom: 1px solid #e1e1e1;
          &:hover {
            background-color: #409eff;
            color: #ffffff;
          }
          &:last-child{
            border-bottom:0;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterViewSimpleDiagram.vue